import { render, staticRenderFns } from "./PackageRow.vue?vue&type=template&id=74f1e60d&scoped=true"
import script from "./PackageRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./PackageRow.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PackageRow.vue?vue&type=style&index=0&id=74f1e60d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f1e60d",
  null
  
)

export default component.exports